export type BackendStatus = 'Pending' | 'Confirmed' | 'Failed';
export type AdminStatus = 'Pending' | 'Approved' | 'Rejected';

export function mapBackendStatusToAdmin(status: BackendStatus): AdminStatus {
  switch (status) {
    case 'Confirmed':
      return 'Approved';
    case 'Failed':
      return 'Rejected';
    default:
      return 'Pending';
  }
}
